import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getPrivacyPolicy = createAsyncThunk('privacyPage/getPrivacyPolicy', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getPrivacyPolicy();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
